import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./rootReducer";

import createSagaMiddleware from 'redux-saga';
//TODO: Перенести saga в app
import rootSaga from '../saga/rootSaga';

const sagaMiddleware = createSagaMiddleware();

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware))
);

export type RootState = ReturnType<typeof store.getState>

sagaMiddleware.run(rootSaga);
